import { useEffect } from 'react';
import { FieldValues, useForm, UseFormProps } from 'react-hook-form';

import { qalFormStartAction } from '~/thunks/analytics';

import { useAppDispatch } from './useSelectors';

export function useFormWithAnalytics<
  TFieldValues extends FieldValues = FieldValues,
  TContext = unknown,
  // TTransformedValues extends FieldValues | undefined = undefined,
>(props?: UseFormProps<TFieldValues, TContext>) {
  const form = useForm<TFieldValues, TContext>(props);

  const dispatch = useAppDispatch();

  useEffect(() => {
    if (form.formState.isDirty) {
      dispatch(qalFormStartAction());
    }
  }, [dispatch, form.formState.isDirty]);

  return form;
}
